module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IgHURY/tc-custom/9781488007637.jpg?1705019890510",
      "alt": "This image is the cover for the book Mistletoe Daddy, Cowboy Country"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mistletoe Daddy, Cowboy Country\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Countdown to a Christmas Baby")]), _c('br'), _c('br'), _vm._v("After Vivian Grainger buys him at the town’s charity bachelor auction, Nick McKenna feels obligated to provide his carpentry skills. He’ll help the bubbly blonde construct her dream spa and beauty shop in time for Christmas—but the burly cowboy won’t be sticking around. When he realizes Vivian is pregnant, though, everything changes. Seeing the joy she brings to everyone around her despite the difficulties she’s overcome, it’s clear to Nick that Vivian—and her child—are what’s missing from his life. As they build her dream shop together, Nick will do his best to build a path to Vivian’s heart.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Deb Kastner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("~Love Courageously~Award-winning author Deb Kastner writes stories of faith, family and community in a small-town western setting.  Deb’s books contain sigh-worthy heroes and strong heroines facing obstacles that draw them closer to each other and the Lord. She lives in Colorado with her husband. She is blessed with three grown daughters and two grandchildren. She enjoys spoiling her grandkids, movies, music, reading, musical theater and exploring Colorado on horseback.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0